const getHostname = (): string => window.location.hostname;

export { getHostname };
